import { MatDialogConfig } from "@angular/material/dialog";
import { EmployeeFileDocumentDialogData } from "src/app/modules/shared/models/employee-file-document-dialog-data.model";

/**
 * Event payload for opening a file document dialog from the microfrontend.
 */
export interface OpenFileDocumentEvent {
  config: MatDialogConfig<EmployeeFileDocumentDialogData>;
}

/**
 * Process types a microfrontend can announce; the host maps each one to its own snackbar message.
 */
export type MicrofrontendProcessType = "notify-pending-documentation";

/**
 * Event payload dispatched by a microfrontend when it started a POS process (processOrchestratorId).
 */
export interface MicrofrontendProcessCreatedDetail {
  processOrchestratorId: string;
  processType: MicrofrontendProcessType;
}

/**
 * Event dispatched by a microfrontend after a POS process was created. It is cancelable:
 * the host calls preventDefault() once it showed the confirmation, so the microfrontend can
 * tell (dispatchEvent returns false) whether to fall back to its own message.
 */
export class MicrofrontendProcessCreatedEvent extends CustomEvent<MicrofrontendProcessCreatedDetail> {
  static readonly eventType = "microfrontend-process-created";
  constructor(detail: MicrofrontendProcessCreatedDetail) {
    super(MicrofrontendProcessCreatedEvent.eventType, { detail, cancelable: true });
  }
}
